export const DESKTOP_LIST_WIDTH = 776;
export const FILTERS_HEIGHT = 100;
